<template lang="pug">
  .component-notification.pm-notification
    .notification(:class="{ success: (notification.style === 'success'), alert: (notification.style === 'alert'), warning: (notification.style === 'warning') }")
      button.close-button(aria-label="Close alert", type="button", @click="removeNotification")
        span.fa.fa-times(aria-hidden="true")
      small {{notification.code}}
      h4
        strong {{ notification.title }}
      template(v-if="Array.isArray(notification.subtitle)")
        .subtitle(v-for="subtitle in notification.subtitle" ) {{ subtitle }}
      template(v-else)
        .subtitle {{ notification.subtitle }}
</template>
<script type="text/babel">
    export default{
        name: "Notification",
        methods: {
            removeNotification: function () {
                this.$store.dispatch('removeNotification', this.notification)
            }
        },
        created() {
            setTimeout(() => {
                this.removeNotification()
            }, 5000);
        },
        props: ['notification']
    }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// Notification.vue?5ff3e87c